"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ASSOCIATED_TOKEN_PROGRAM_ID = exports.TOKEN_PROGRAM_ID = exports.TEN_BIGNUM = exports.SOL = exports.USDC_DECIMALS = exports.PROGRAM_SEEDS = exports.ZEBEC_CARD_PROGRAM = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const dotenv_1 = __importDefault(require("dotenv"));
const anchor_1 = require("@coral-xyz/anchor");
const web3_js_1 = require("@solana/web3.js");
dotenv_1.default.config();
/**
 * Zebec Card Program Ids
 */
exports.ZEBEC_CARD_PROGRAM = {
    /** Mainnet Program Id */
    mainnet: "HxZq3iRwN2a2myikHz8JNVufJ7FM92xV8kNvFpQaRgKd",
    /** Devnet Program Id */
    devnet: "HxZq3iRwN2a2myikHz8JNVufJ7FM92xV8kNvFpQaRgKd",
};
exports.PROGRAM_SEEDS = {
    cardPdaSeed: "zebec_instant_card_init",
    buyerPdaSeed: "buyer",
};
// /**
//  * USDC Mint Address
//  */
// export const USDC = new PublicKey(
// 	process.env.USDC_MINT_ADDRESS
// 		? process.env.USDC_MINT_ADDRESS
// 		: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
// );
/** USDC Decimals = 6 */
exports.USDC_DECIMALS = 6;
/**
 * WSOL Mint Address
 */
exports.SOL = new web3_js_1.PublicKey("So11111111111111111111111111111111111111112");
/** BigNumber Object for 10 */
exports.TEN_BIGNUM = (0, bignumber_js_1.default)(10);
exports.TOKEN_PROGRAM_ID = anchor_1.utils.token.TOKEN_PROGRAM_ID;
exports.ASSOCIATED_TOKEN_PROGRAM_ID = anchor_1.utils.token.ASSOCIATED_PROGRAM_ID;
